import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { Modal } from "antd";


const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const FadeIn = styled.div`
  max-width: 800px;
  margin: 0 auto;
  animation: ${fadeIn} 0.8s ease-out;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #0077cc;
  margin-bottom: 2rem;
`;

const Paragraph = styled.p`
  font-size: 1.15rem;
  color: #444;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const CTA = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.6rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  display: inline-block;
  margin-top: 1rem;

  &:hover {
    background-color: #005fa3;
  }
`;

const FinalNote = styled.p`
  font-size: 1rem;
  color: #666;
  margin-top: 3rem;
  font-style: italic;

  strong {
    color: #000;
  }
`;
const ExtraActions = styled.p`
  margin-top: 2rem;
  font-size: 1rem;
  color: #444;
  a {
    color: #0077cc;
    text-decoration: underline;
    font-weight: 600;

    &:hover {
      color: #005fa3;
    }
  }
`;
const ProgressContainer = styled.div`
  margin: 2rem auto 1rem;
  width: 80%;
  max-width: 400px;
  background: #eee;
  border-radius: 8px;
  overflow: hidden;
`;


const ProgressBar = styled.div<{ progress: number }>`
  height: 8px;
  width: ${({ progress }) => progress}%;
  background-color: #0077cc;
  transition: width 0.3s ease;
`;

const Instruction = styled.p`
  font-size: 1rem;
  color: #444;
  margin-top: 1rem;
  line-height: 1.5;
  text-align: center;
  a {
    color: #0077cc;
    cursor: pointer;
    font-weight: 600;
  }
`;


const Agradecimento = () => {

   const navigate = useNavigate();
    const [progress, setProgress] = useState(0);
    
    const [isPaused, setIsPaused] = useState(false);
     const totalDuration = 20000;//8s
    const startTimeRef = useRef<number | null>(null);
    const animationFrameRef = useRef<number | null>(null);

  const animateProgress = (timestamp: number) => {
    if (!startTimeRef.current) startTimeRef.current = timestamp;
    const elapsed = timestamp - startTimeRef.current;

    const percent = Math.min((elapsed / totalDuration) * 100, 100);
    setProgress(percent);

    if (percent < 100 && !isPaused) {
      animationFrameRef.current = requestAnimationFrame(animateProgress);
    } else if (percent >= 100 && !isPaused) {
      abrirModal();
    }
  };

    useEffect(() => {
    const timeout = setTimeout(() => {
      startTimeRef.current = performance.now(); // garante valor
      animationFrameRef.current = requestAnimationFrame(animateProgress);
    }, 500); // 500ms garante tempo de montagem total
  
    return () => {
      clearTimeout(timeout);
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);
   const abrirModal = () => {
    setIsPaused(true);
    Modal.confirm({
      title: "Vamos para a próxima etapa?",
      content: "Gostaria de continuar agora ou precisa de mais tempo para ler?",
      okText: "✅ Sim, vamos!",
      cancelText: "⏳ Ainda estou lendo",
      onOk() {
        navigate("/queroviajar");
      },
      onCancel() {
        // Reinicia progresso com mais tempo
        startTimeRef.current = null;
        setProgress(0);
        setIsPaused(false);
        animationFrameRef.current = requestAnimationFrame(animateProgress);
      }
    });
  };
 
  
  return (
    <Wrapper>
      <FadeIn>
        <Title>🎉 Pagamento confirmado com sucesso!</Title>

         <ProgressContainer>
          <ProgressBar progress={progress} />
        </ProgressContainer>

         <Instruction>
          <strong>Mas ainda não acabamos...</strong> <br />
          Após ler as instruções e informações abaixo, gostaria de te fazer uma pergunta que pode ser muito vantajosa para você. <br />Se quiser ir logo, 
           <a onClick={() => navigate("/queroviajar")}> clique aqui</a>, ou aguarde para ser redirecionado.
        </Instruction>

        <Paragraph>
          Seu anúncio está sendo preparado e será publicado em breve nas nossas plataformas de venda.
        </Paragraph>

        <Paragraph>
          Você receberá atualizações no seu e-mail e no WhatsApp cadastrado.  
          Se precisar editar alguma informação ou tiver dúvidas, estamos aqui para ajudar.
        </Paragraph>

        <CTA href="https://wa.me/message/H7PTB2XYZUDAO1" target="_blank">
          📲 Falar com o suporte no WhatsApp
        </CTA>

        <FinalNote>
          Obrigado por confiar na <strong>Multicotas</strong>.<br />
          Vamos trabalhar para que sua cota encontre o comprador ideal!
        </FinalNote>
     

      </FadeIn>
    </Wrapper>
  );
};

export default Agradecimento;
